import { render, staticRenderFns } from "./ServiceRequestDetails.vue?vue&type=template&id=ae0e3d3c&"
import script from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceRequestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae0e3d3c')) {
      api.createRecord('ae0e3d3c', component.options)
    } else {
      api.reload('ae0e3d3c', component.options)
    }
    module.hot.accept("./ServiceRequestDetails.vue?vue&type=template&id=ae0e3d3c&", function () {
      api.rerender('ae0e3d3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/requests/ServiceRequestDetails.vue"
export default component.exports